import { Component, Inject, NgZone, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from 'redux';
import { Subscription } from 'rxjs';
import { filter, tap } from 'rxjs/operators';

import { AuthService } from '../auth/auth.service';
import { StateToProps, storeObserver } from '../store';
import { STORE } from '../store.metadata';

import { retrieveInitData } from './tdcf-form.action';
import { TranslationKeyMap } from './tdcf-form.i18n';
import { State, storeStateMapper } from './tdcf-form.state';
import { Mode } from './tdcf.model';

@Component({
    selector: '[cmpsTdcf]',
    templateUrl: './tdcf.component.html',
    host: {
        class: 'cmps-tdcf',
    },
})
export class TdcfComponent implements OnInit, OnDestroy, StateToProps<State> {
    i18n = TranslationKeyMap;
    Mode = Mode;
    private _storeSub: Subscription;
    state: State;
    private _routeSub: Subscription;
    templateId: number;
    userId: number;

    constructor(
        private readonly _ngZone: NgZone,
        private readonly _activatedRoute: ActivatedRoute,
        @Inject(STORE) private readonly _store: Store,
        private readonly _authService: AuthService,
    ) {}

    ngOnInit(): void {
        this._storeSub = storeObserver<State>(this._store, storeStateMapper)
            .pipe(
                tap((state) =>
                    this._ngZone.run(() => {
                        this.state = state;
                        this.stateToProps();
                    }),
                ),
            )
            .subscribe();

        this._routeSub = this._activatedRoute.queryParams
            .pipe(
                // eslint-disable-next-line no-prototype-builtins
                filter((queryParams) => queryParams.hasOwnProperty('tpl')),
                tap((queryParams) => {
                    this.templateId = queryParams.tpl;
                    this.userId = queryParams.user || this._authService.user.id;
                    this._store.dispatch(
                        retrieveInitData(this.templateId, this.userId),
                    );
                }),
            )
            .subscribe();
    }

    ngOnDestroy(): void {
        if (this._routeSub) {
            this._routeSub.unsubscribe();
        }
        if (this._storeSub) {
            this._storeSub.unsubscribe();
        }
    }

    stateToProps(): void {}
}
